import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ADD_HISTORY_MODELS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AddHistoryModelsDataActionTypes, IAddHistoryModels } from './types';
import modelsApi from 'src/utils/api/modelsApi';

export const loadAddHistoryModels =
  (
    addHistoryModels: IAddHistoryModels,
    modelId: string,
  ): ThunkAction<Promise<void>, State, null, AddHistoryModelsDataActionTypes> =>
  async (dispatch) => {
    dispatch({ type: ADD_HISTORY_MODELS + REQUEST });
    try {
      const payload = await modelsApi.loadAddHistoryModels(
        addHistoryModels,
        modelId,
      );
      dispatch({ type: ADD_HISTORY_MODELS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ADD_HISTORY_MODELS + FAILURE, error });
    }
  };

export const addHistoryModelsIdle = () => ({ type: ADD_HISTORY_MODELS + IDLE });
